function loadEcommerce(){
	var script = document.createElement('script');
    script.src = "//cdn.shopify.com/s/files/1/0014/9186/1613/t/4/assets/facebook-pixel-google-ecommerce-code.js?v=69752084597238007581533127030";
    document.getElementsByTagName('head')[0].appendChild(script);
}

$(function(){
  	var email_format = /^([a-zA-Z0-9_\.\-])+@([a-zA-Z0-9_\-\.])+(\.[a-zA-Z]{2,4})$/;
	var overlay = $('<div class="overlay"><i class="loader fa fa-pulse">&#xf110;</i></div>');
  
	// SMARTRESIZE
	(function($,sr){
	  var debounce = function (func, threshold, execAsap) {
		  var timeout;

		  return function debounced () {
			  var obj = this, args = arguments;
			  function delayed () {
				  if (!execAsap)
					  func.apply(obj, args);
				  timeout = null;
			  };

			  if (timeout)
				  clearTimeout(timeout);
			  else if (execAsap)
				  func.apply(obj, args);

			  timeout = setTimeout(delayed, threshold || 200);
		  };
	  }
	  
	  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

	})(jQuery,'smartresize');
  
  	/*$('<i id="to-top" class="fa fa-chevron-circle-up"></i>')
		.appendTo('body')
    	.click(function(){
			var el = $(this);
			var top = $('header').offset().top;
			$('html, body').animate({ scrollTop: top }, 300, function(){
				el.removeClass('active');
			});
		});
  
 	$(window).scroll(function(){
		if($('#to-top').length==1){
			if(!$('#header').isOnScreen()){
				if(!to_top.hasClass('active')){
					to_top.addClass('active');
				}
			}
			else to_top.removeClass('active');
		}
	});*/
  
    $('.badge--sold-out').each(function(){
      if($(this).next('img').attr('src').indexOf('_sold_out') !== -1){
      	$(this).remove();
      }
    });
  
	// isOnScreen
	$.fn.isOnScreen = function(){
		var win = $(window);
		
		var viewport = {
			top : win.scrollTop(),
			left : win.scrollLeft()
		};
		viewport.right = viewport.left + win.width();
		viewport.bottom = viewport.top + win.height();
		
		var bounds = this.offset();
		// HA LÉTEZIK AZ ELEMENT
		if(typeof bounds !== typeof undefined){
			bounds.right = bounds.left + this.outerWidth();
			bounds.bottom = bounds.top + this.outerHeight();
		}
		else return false;
		
		return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	};
  
  
  	$('.image-gallery').photoSwipe();
  
  $('form.remote-request').submit(function(e){
  	e.preventDefault();
    
    var form = $(this);
    
    form.find('.alert').remove();
	if(!form.hasClass('no-overlay')) form.prepend(overlay.clone());
    $('html').addClass('wait');
    
    $.post(form.attr('action'), form.serialize(), function(result){
    	if(result.success==1){
            form[0].reset();
          }
        if(result.msg!=''){
          form.prepend(result.msg);
          if(!form.find('.alert').isOnScreen()){
            $('html, body').scrollTop(form.offset().top);
          }
        }
        else alert(result.log);
      
    }, 'json').fail(function(){
    	alert('An error occured during operation! Please try again later.');
    }).always(function(){
      	$('html').removeClass('wait');
    	form.find('.overlay').remove();
    });
  });
  
  $('body').on('click', '.alert > .close', function(){
  	$(this).closest('.alert').remove();
  });
  
  $('#lang-select').change(function(){
    window.location.href = $(this).val();
  });
	
  
  if($('#t-product').length > 0){
    $('#t-product').each(function(){
      $(this).parent().addClass('responsive-table');
    });
  }
  
  if(Cookies.get('cookiePolicy')==undefined){
    var policy_text = 'We use cookies to provide you with the best possible experience on our site. By continuing to use our site you agree to our use of cookies.';
    var policy_banner = $('<div id="cookie-policy-banner">').html('<div><a href="#" id="close-cookie-policy-banner" class="btn btn--small">OK</a>'+policy_text+'</div>');
    $('body').append(policy_banner).on('click', '#cookie-policy-banner #close-cookie-policy-banner', function(e){
      e.preventDefault();

      Cookies.set('cookiePolicy', 'ok', { expires: 365, domain: '.scitecnutrition.com' });

      $(this).closest('#cookie-policy-banner').fadeOut();
    });
  }
  
  if(Cookies.get('language')!='us'){
    Cookies.set('language', 'us', { expires: 365, domain: 'scitecnutrition.com' });
  }
});